import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { Language } from '../../types/data-model';

export const selectLanguage = createSelector(
  (state: AppState) => state.languages,
  (languages: Language[]) => languages
);
